import axios from 'axios';
import Cookies from 'js-cookie';

const AUTH_BASE_URL = 'https://unbot.io/api/v1.0/auth';

/**
 * Notify the back-end (which pings Discord) that an email was entered at the
 * first signup step — before the account exists. Lets the team re-engage
 * visitors who start but don't finish.
 *
 * Fire-and-forget: a failed notification must NEVER block the funnel, so this
 * swallows its own errors and always resolves.
 */
export const notifySignupLead = async (mail) => {
  try {
    const sponsor = Cookies.get('sponsor');
    const payload = { mail };
    if (sponsor) {
      payload.sponsor = sponsor;
    }
    await axios.post(`${AUTH_BASE_URL}/lead`, payload);
  } catch (error) {
    // Intentionally swallowed — the lead ping is best-effort.
  }
};

/**
 * Create the account from the email + password step (no userType yet). The
 * account is persisted here so the user exists even if they drop off before
 * choosing a profile type. Returns the raw API payload ({ jwt, _id, ... } or
 * { error }).
 */
export const register = async ({ mail, password }) => {
  const sponsor = Cookies.get('sponsor');
  const payload = { mail, password };
  if (sponsor) {
    payload.sponsor = sponsor;
  }
  const response = await axios.post(AUTH_BASE_URL, payload);
  return response.data;
};
